export default "__VITE_ASSET___22uD3w6__"